<form (submit.prevent)="onSubmit()">
  <ui-simple-dialog-layout (clickCancel)="clickCancel.emit()">
    <ng-container slot="title">
      {{ 'cockpit.settings.members.inviteCreateDialog.title' | transloco }}
    </ng-container>
    <div class="flex flex-col gap-5">
      <ui-input-label>
        {{ 'cockpit.settings.members.inviteCreateDialog.form.emailLabel' | transloco }}
        <ui-input-simple
          type="email"
          [placeholder]="
            'cockpit.settings.members.inviteCreateDialog.form.emailPlaceholder' | transloco
          "
          [formField]="form.email"
        />
        <app-field-errors slot="bottom" [fieldState]="form.email()" />
      </ui-input-label>
      <ui-input-label>
        {{ 'cockpit.settings.members.inviteCreateDialog.form.roleLabel' | transloco }}
        <ui-select [formField]="form.role">
          <option
            value="ORGANIZATION_MEMBER"
            [selected]="form.role().value() === 'ORGANIZATION_MEMBER'"
          >
            {{ 'ORGANIZATION_MEMBER' | organizationRole | transloco }}
          </option>
          <option
            value="ORGANIZATION_ADMIN"
            [selected]="form.role().value() === 'ORGANIZATION_ADMIN'"
          >
            {{ 'ORGANIZATION_ADMIN' | organizationRole | transloco }}
          </option>
        </ui-select>
        <app-field-errors slot="bottom" [fieldState]="form.role()" />
      </ui-input-label>
    </div>
    <ui-button slot="footer" (click)="clickCancel.emit()" mode="outlined" type="button">
      {{ 'cockpit.settings.members.inviteCreateDialog.form.cancelButton' | transloco }}
    </ui-button>
    <ui-button slot="footer" type="submit" [loading]="isCreateLoading()">
      {{ 'cockpit.settings.members.inviteCreateDialog.form.submitButton' | transloco }}
    </ui-button>
    @if (form().invalid() && showValidationErrors()) {
      <ui-input-error slot="error">{{
        'cockpit.settings.members.inviteCreateDialog.form.validation' | transloco
      }}</ui-input-error>
    } @else if (createError()) {
      <ui-input-error slot="error">{{
        'cockpit.settings.members.inviteCreateDialog.form.errors.createFailed' | transloco
      }}</ui-input-error>
    }
  </ui-simple-dialog-layout>
</form>
